<template>
  <v-container fluid class="pa-0 ma-0">
    <v-app id="inspire">
      <v-card class="elevation-0">
        <v-img class="white--text" max-height="590px" src="@/assets/aboutusbg.jpg">
          <v-container>
            <div class="mt-16 mx-lg-8 pt-lg-16">
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="5">
                  <v-card class="ma-2 mt-16">
                    <div class="waviy">
                      <h1 class="clrbluetext font-weight-bold">
                        65 inch Sactin Interactive Panel
                      </h1>
                      <h2 class="linespht spans clrbluetext font-weight-bold">
                        Discover. Discuss. Develop.
                      </h2>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="8" md="7">
                  <v-card
                    class="pa-2 ma-2 d-flex align-center justify-center htlargef mt-sm-16 mt-xl-8"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/dgxg.png"
                      class="fill-height zoom-effect"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-img>
      </v-card>

      <!-- start sec part -->
      <!-- start sec part -->
      <v-card class="elevation-0 bgpanel">
        <v-container>
          <div>
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12">
                <!-- observer wrapper for mobile heading -->
                <div ref="leftHeadingMobile" class="observer">
                  <h1
                    class="rainbow-text text-center fontfamMon font-weight-bold linespht display-1 anim-item fade-up delay-100"
                    style="font-size: clamp(20px, 4vw, 32px) !important"
                  >
                    65" Sactin Interactive Panel
                  </h1>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="mx-lg-8">
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12">
                <div ref="imageCard2" class="observer">
                  <v-card
                    class="px-2 mx-2 pb-2 mb-2 d-none d-sm-block align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/panel/single-meeting65panel1.jpg"
                      class="fill-height rounded-xl"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>

              <!-- RIGHT COLUMN -->
              <v-col cols="12">
                <v-card class="ma-2">
                  <div ref="paragraph" class="observer">
                    <p
                      class="mt-6 mt-lg-14 text-justify linespht1 black--text body-1 anim-item zoom-in delay-200"
                    >
                      Interactive flat panel displays are collaboration solutions designed
                      for interactive whiteboarding, videoconferencing, screen sharing,
                      and more. The latest technologies let you securely connect to
                      participants whether they're in the room or joining remotely.
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <!-- observer wrapper for image card -->
              <v-col>
                <div ref="imageCard1" class="observer">
                  <v-card
                    class="pb-2 mb-2 d-block d-sm-none align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/panel/single-meeting65panel1.jpg"
                      class="fill-height rounded-xl"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
      <!-- end sec part -->

      <!-- start 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Features
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container>
        <v-card class="black--text elevation-0" dark>
          <v-container fluid>
            <v-row class="text-center">
              <!-- Step 1 -->
              <v-col cols="12" sm="8">
                <div ref="paragraph2" class="observer">
                  <ul class="body-1 text-justify anim-item zoom-in delay-200">
                    <li class="mb-1">Perfect 4K resolution</li>
                    <li class="mb-1">Front audio stereophonic speaker</li>
                    <li class="mb-1">Industrial grade aluminium frame</li>
                    <li class="mb-1">
                      Multiple signal input HDMI, VGA, Video, YPbPr, TV etc.
                    </li>
                    <li class="mb-1">Password / Pattern Lock protected</li>
                    <li class="mb-1">Front audio stereophonic speaker</li>
                    <li class="mb-1">4mm protect glass and anti-scratch</li>
                    <li class="mb-1">20 points touch, greater than 5~8ms response</li>
                    <li class="mb-1">
                      Support APK install & authorize management, permit or forbidden
                      application
                    </li>
                  </ul>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  color="orange  rounded-xl"
                  dark
                  href="/panelPDF/panel65.pdf"
                  download
                >
                  Download Specification
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <!-- end 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        I/O Port
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <div ref="imageCard3" class="observer">
                    <v-card
                      class="px-2 mx-2 pb-2 mb-2 align-center justify-center htlargef2 anim-item zoom-in delay-200"
                      height="100%"
                    >
                      <v-img
                        src="@/assets/panel/IO-port-65panel2.png"
                        class="fill-height rounded-xl"
                        contain
                        max-width="100%"
                      />
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Description
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0">
          <v-container class="px-3 px-sm-4">
            <div ref="paragraph3" class="observer">
              <v-simple-table dark class="black white--text anim-item zoom-in delay-200">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in desserts" :key="item.name">
                      <td>{{ item.name }}</td>
                      <td>{{ item.description }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <!-- end 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Dimensions
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <div ref="imageCard4" class="observer">
                    <v-card
                      class="px-2 mx-2 pb-2 mb-2 align-center justify-center htlargef2 anim-item zoom-in delay-200"
                      height="100%"
                    >
                      <v-img
                        src="@/assets/panel/65panel3.png"
                        class="fill-height rounded-xl"
                        contain
                        max-width="100%"
                      />
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Pictures
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12" sm="3">
                  <div ref="imageCard5" class="observer">
                    <v-card
                      class="px-2 mx-2 pb-2 mb-2 align-center justify-center htlargef2 anim-item zoom-in delay-200"
                      height="100%"
                    >
                      <v-img
                        src="@/assets/panel/p1-65panel4.jpg"
                        class="fill-height rounded-xl"
                        contain
                        max-width="100%"
                      />
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12" sm="3">
                  <div ref="imageCard6" class="observer">
                    <v-card
                      class="px-2 mx-2 pb-2 mb-2 align-center justify-center htlargef2 anim-item zoom-in delay-200"
                      height="100%"
                    >
                      <v-img
                        src="@/assets/panel/p2-65panel4.jpg"
                        class="fill-height rounded-xl"
                        contain
                        max-width="100%"
                      />
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12" sm="3">
                  <div ref="imageCard7" class="observer">
                    <v-card
                      class="px-2 mx-2 pb-2 mb-2 align-center justify-center htlargef2 anim-item zoom-in delay-200"
                      height="100%"
                    >
                      <v-img
                        src="@/assets/panel/p3-65panel4.jpg"
                        class="fill-height rounded-xl"
                        contain
                        max-width="100%"
                      />
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12" sm="3">
                  <div ref="imageCard8" class="observer">
                    <v-card
                      class="px-2 mx-2 pb-2 mb-2 align-center justify-center htlargef2 anim-item zoom-in delay-200"
                      height="100%"
                    >
                      <v-img
                        src="@/assets/panel/p4-65panel4.jpg"
                        class="fill-height rounded-xl"
                        contain
                        max-width="100%"
                      />
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <!-- start footer -->
      <WebsiteFooter />
      <!-- end footer -->
    </v-app>
  </v-container>
</template>

<script>
import WebsiteFooter from "../WebsitePages/WebsiteFooter.vue";
export default {
  components: {
    WebsiteFooter,
  },
  data() {
    return {
      observer: null,
      desserts: [
        {
          name: " On/Off button",
          description: "One key power on/off or standby button ",
        },
        {
          name: "USB port",
          description:
            "Connecting both Android and OPS system, For USB devices, like keyboard, mouse, USB storage etc.",
        },
        {
          name: " USB port",
          description: "Connecting both Android and OPS system, For USB devices etc.",
        },
        {
          name: "HDMI port",
          description: "HDMI input port, use to connect computer or TV box by HDMI cable",
        },
        {
          name: "USB port of Touch",
          description:
            "Connecting a USB cable from the computer to TAIO for touch operation",
        },
        {
          name: "Speaker",
          description: "Front side speaker, 2*10W",
        },
        {
          name: "Remote sensor",
          description: "Receiving infrared control of the remote controller",
        },
        {
          name: "OPS",
          description: "slot Connecting OPS computer to TAIO monitor.",
        },
        {
          name: "AC switch",
          description: "AC power on/off switch button.",
        },
        {
          name: "AC socket",
          description: "110~240V AC power input socket",
        },
        {
          name: " MIC port",
          description: "Connecting microphone",
        },
        {
          name: "RS232 port",
          description:
            "Connecting RS232 cable, used for communication with a monitor from the computer",
        },
        {
          name: "Earphone port",
          description: "Connecting earphone or audio device",
        },
        {
          name: "PC audio input port",
          description: "Connecting audio device for VGA port",
        },
        {
          name: " VGA port",
          description: "Connecting VGA cable",
        },
        {
          name: "COAX out port Connecting Coaxial digital signal",
          description: "Connecting Coaxial digital signal",
        },
        {
          name: "Connecting Coaxial digital signal",
          description: "Connecting Lan",
        },

        {
          name: "2.4G WIFI port",
          description: "Connecting 2.4G antenna, use for WIFI application",
        },
        {
          name: "5G WIFI port",
          description: "Connecting 5G antenna, use for WIFI application",
        },
      ],
    };
  },
  methods: {
    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
  },
  mounted() {
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer1.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    document.querySelectorAll(".process-circle").forEach((el) => {
      observer1.observe(el);
    });
    const options = {
      root: null,
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const anim = entry.target.querySelector(".anim-item");
        if (!anim) return;

        if (entry.isIntersecting) {
          anim.classList.add("in-view"); // play animation
        } else {
          anim.classList.remove("in-view"); // reset when out of view
        }
      });
    }, options);

    [
      "leftHeadingMobile",
      "imageCard1",
      "imageCard2",
      "imageCard3",
      "imageCard4",
      "imageCard5",
      "imageCard6",
      "imageCard7",
      "imageCard8",
      "rightHeadingDesktop",
      "paragraph",
      "paragraph2",
      "paragraph3",
    ].forEach((ref) => {
      const el = this.$refs[ref];
      if (el) observer.observe(el);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: white;
}
::v-deep .theme--light.v-sheet {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white;
}
::v-deep .theme--dark.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: black;
}
::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.linespht {
  line-height: 1.5;
  letter-spacing: 2px;
}
.linespht1 {
  line-height: 1.5;
  letter-spacing: 1px;
}
@media screen and (min-width: 1100px) and (max-width: 1300px) {
  .htlargef {
    height: 90% !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1670px) {
  .htlargef {
    height: 90% !important;
  }
  .fd50SS {
    font-size: 50px !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1671px) {
  .htlargef {
    height: 70% !important;
  }
  .fd50SS {
    font-size: 60px !important;
  }
  .htlargeproductscn {
    height: 710px !important;
  }
  .htlargecertificatescn {
    height: 710px !important;
  }
}
.htlargef2 {
  height: 100% !important;
}
.clrblues {
  background-color: #04357e !important;
  color: white;
}
@media screen and (min-width: 700px) {
  .fd20 {
    font-size: 20px;
  }
  .fd50 {
    font-size: 40px;
    line-height: 1.5;
    letter-spacing: 2px;
  }
  .fd50SS {
    font-size: 50px;
  }
  .htlargeproductscn {
    height: 1115px;
  }
  .fd20ss {
    font-size: 30px !important;
  }
}

/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  /* background: #e5e5e5; */
  background: white;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
  /* height: 200px; */
  /* height: 260px; */
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}
.brradius {
  border-radius: 12px !important;
}

/* start slider */
.v-slide-group__prev,
.v-slide-group__next {
  color: purple; /* Customize the arrow color */
}
/* end slider */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}
.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}

/* end a1 */

/* a2 */

.contentan {
  position: relative;
}

.contentan h2 {
  color: #fff;
  font-size: 3em;
  position: absolute;
  transform: translate(-50%, -50%);
}

.contentan h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px #04357e;
  /* -webkit-text-stroke: 2px  #2A65BF; */
}

.contentan h2:nth-child(2) {
  color: #04357e;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      16% 44%,
      33% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      15% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.letpx {
  left: 80px;
}
/* end a2 */
.clrbluetext {
  /* color: #04357e !important; */
  color: black;
}
/* ::v-deep .bgpanel.v-card.v-sheet.theme--light {
  background-color: #f8f8ff !important;
}
::v-deep .bgpanel {
  background-color: #f8f8ff !important;
} */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}

.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}
.rainbow-text {
  background: linear-gradient(
    90deg,
    red,
    orange,
    yellow,
    green,
    blue,
    indigo,
    violet,
    red
  );
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-move 8s linear infinite;
}

@keyframes rainbow-move {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
/* end a1 */
.process-circle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #e29803;
  /* Vuetify primary color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.process-circle-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.process-circle-num {
  position: absolute;
  bottom: -15px;
  background: #e29803;
  color: #fff;
  border-radius: 50%;
  padding: 5px 12px;
  font-weight: bold;
}
/* Shared hidden state */
.anim-item {
  opacity: 0;
  transition-property: opacity, transform;
  transition-duration: 800ms;
  transition-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);
}

/* When in-view */
.anim-item.in-view {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

/* Types */
.fade-up {
  transform: translateY(40px);
}
.fade-up.in-view {
  transform: translateY(0);
}

.fade-left {
  transform: translateX(40px);
}
.fade-left.in-view {
  transform: translateX(0);
}

.zoom-in {
  transform: scale(0.9);
}
.zoom-in.in-view {
  transform: scale(1);
}

/* Optional delay helpers */
.delay-100 {
  transition-delay: 0.1s;
}
.delay-150 {
  transition-delay: 0.15s;
}
.delay-200 {
  transition-delay: 0.2s;
}
.delay-300 {
  transition-delay: 0.3s;
}
@keyframes zoomInOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* zoom in */
  }
  100% {
    transform: scale(1); /* back to normal */
  }
}

.zoom-effect {
  animation: zoomInOut 6s ease-in-out infinite; /* continuous zoom */
  transition: transform 0.3s ease-in-out;
}

.process-circle {
  position: relative;
  background: white;
  border-radius: 50%;
  padding: 30px;
  text-align: center;
  transition: all 0.4s ease; /* smooth animation */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg); /* zoom + tilt */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* stronger glow */
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 10px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg); /* spin icon */
}

.process-circle-text h3 {
  margin: 0;
  font-size: 18px;
  transition: color 0.3s ease;
}

.process-circle:hover .process-circle-text h3 {
  color: #e29803; /* change text color on hover */
}
.process-circle {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
}

.process-circle.visible {
  opacity: 1;
  transform: translateY(0);
}

.process-circle:nth-child(1) {
  transition-delay: 0.2s;
}
.process-circle:nth-child(2) {
  transition-delay: 0.4s;
}
.process-circle:nth-child(3) {
  transition-delay: 0.6s;
}
.process-circle:nth-child(4) {
  transition-delay: 0.8s;
}
.process-circle {
  width: 150px; /* fixed width */
  height: 150px; /* equal height */
  border-radius: 50%; /* make it a circle */
  background: white;
  display: flex;
  flex-direction: column; /* stack icon + text + number */
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto; /* center inside column */
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg);
}

.process-circle-num {
  position: absolute;
  bottom: -20px; /* place number outside circle */
  font-weight: bold;
  font-size: 18px;
  color: white;
}
@keyframes pulseLoop {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  /* 👇 add looping animation */
  animation: pulseLoop 3s ease-in-out infinite;
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle-num {
  position: absolute;
  bottom: -20px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
.fontfamMon {
  font-family: Montserrat !important;
}
</style>
